import { useDispatch } from 'react-redux';

import RegisterInput from '../components/RegisterInput';
import RegisterImage from '../assets/register-image.webp';
import { asyncRegisterUser } from '../states/users/actions';

const RegisterPage = () => {
  const dispatch = useDispatch();
  const onRegister = ({ name, email, password }) => {
    dispatch(asyncRegisterUser({ name, email, password }));
  };
  return (
    <>
      <div className="hidden md:block bg-cover bg-center" style={{ backgroundImage: `url(${RegisterImage})` }} />
      <div className="grid gap-5 pb-24 px-6 py-10 xl:px-[40px]  md:pb-[40px] custom-min-height content-center">
        <h1 className="font-black text-2xl tracking-wider text-black">Join ThreadNVote Community</h1>
        <p className="font-light text-black text-lg tracking-wider">Get more features and priviliges by joining to the most helpful community</p>
        <RegisterInput register={onRegister} />
      </div>
    </>
  );
};

export default RegisterPage;
